import { ContextPropagationPlanRequestDto } from '@shared/services/apiService/apiService';

export const CLIENT_RULE_ID_KEY = '__clientRuleId';
export const DEFAULT_RULE_TYPE = 'agent_handoff';
export const DEFAULT_MESSAGE_GROUPS = ['start', 'delayed', 'complete', 'failed'] as const;

export type JsonRecord = Record<string, unknown>;

export type HandoffRuleType = typeof DEFAULT_RULE_TYPE;
export type MessageGroupValue = Record<string, string[]>;
export type VariableExtractionFieldType =
  | 'string'
  | 'number'
  | 'integer'
  | 'boolean'
  | 'array'
  | 'object';
export type VariableExtractionEnumValue = string | number | boolean;
export type VariableExtractionSchemaNode = {
  type: VariableExtractionFieldType;
  description?: string;
  enum?: VariableExtractionEnumValue[];
  properties?: Record<string, VariableExtractionSchemaNode>;
  required?: string[];
  items?: VariableExtractionSchemaNode;
  additionalProperties?: boolean;
};
export type VariableExtractionRootSchema = VariableExtractionSchemaNode & {
  type: 'object';
  properties: Record<string, VariableExtractionSchemaNode>;
  required: string[];
  additionalProperties: false;
};
export type VariableExtractionPlanFormValue = {
  strict: true;
  schema: VariableExtractionRootSchema;
};

export type SessionBoundaryPlan = {
  startAgentId?: string;
  endingAgentIds: string[];
  allowSessionWithoutEndingAgent: boolean;
};

export type ContextSummaryPlan = {
  summary: string;
};

export type HandoffRuleEditorValue = {
  id: string;
  clientRuleId: string;
  ruleType: HandoffRuleType;
  name: string;
  description: string;
  fromAgentId: string;
  toAgentId: string;
  messages: MessageGroupValue;
  contextPropagationPlan?: ContextPropagationPlanRequestDto;
  contextSummaryPlan?: ContextSummaryPlan;
  sessionBoundaryPlan?: SessionBoundaryPlan;
  variableExtractionPlan?: VariableExtractionPlanFormValue;
  raw: JsonRecord;
};
